import { AbstractControl, ValidationErrors } from '@angular/forms';

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;

  if (!value) return null;

  const phoneMaskRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/;

  if (!phoneMaskRegex.test(value)) {
    return { invalidPhone: true };
  }

  return null;
}
